// console.log('Cart drawer contents goes here');

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartDrawerToggle = document.querySelector(
      ".section-header-cart-drawer-toggle"
    );
    this.cartDrawer = this;
    this.cartDrawerClose = this.querySelector(".cart-drawer-close");
    this.cartDrawerOverlay = this.querySelector(".cart-drawer-overlay");
    this.cartDrawerEmptyRedirect = this.querySelector(
      ".cart-drawer-empty-footer"
    );

    this.setAttribute("tabindex", "-1");

    if (this.cartDrawerToggle) {
      this.cartDrawerToggle.addEventListener("click", (event) =>
        this.onClick(event)
      );
    }

    this.cartDrawerClose.addEventListener("click", () => this.close());
    this.cartDrawerClose.addEventListener("keyup", (event) =>
      this.onCloseKeypress(event)
    );
    this.cartDrawerOverlay.addEventListener("click", () => this.close());

    document.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        this.close();
      }
    });

    if (this.cartDrawerEmptyRedirect) {
      this.cartDrawerEmptyRedirect.addEventListener("click", () =>
        this.close()
      );
    }

    // Handle checkout button enable/disable based on phone and availability fields
    this.checkoutButton = this.querySelector("#cart-drawer-checkout-button");
    this.additionalButtonsContainer = this.querySelector(
      "#cart-drawer-additional-buttons"
    );
    this.phoneField = this.querySelector("#attr-phone");
    this.availabilityField = this.querySelector("#attr-availability");

    if (this.checkoutButton && this.phoneField && this.availabilityField) {
      this.validateCheckoutButton();

      // Format phone number as user types
      this.phoneField.addEventListener("input", (e) => {
        this.formatPhoneNumber(e);
        this.validateCheckoutButton();
      });

      // Format phone number on paste
      this.phoneField.addEventListener("paste", (e) => {
        setTimeout(() => {
          this.formatPhoneNumber(e);
          this.validateCheckoutButton();
        }, 0);
      });

      // Format phone number if it already has a value when cart drawer opens
      if (this.phoneField.value) {
        this.formatPhoneNumber({ target: this.phoneField });
      }

      this.availabilityField.addEventListener("input", () =>
        this.validateCheckoutButton()
      );

      // Set up observer for dynamically added additional checkout buttons
      if (this.additionalButtonsContainer) {
        this.observeAdditionalButtons();
      }
    }

    this.previousElement = this.cartDrawerToggle;
  }

  onClick(event) {
    event.preventDefault();

    this.open();
  }

  onCloseKeypress(event) {
    if (event.key === "Enter") {
      this.close();

      // this.cartDrawerToggle.focus();

      // var quickviewElement = document.querySelector('.popup-modal-quickview:not(.inactive)');
      // if(quickviewElement){
      //     quickviewElement.querySelector('button[type="submit"]').focus();
      // }
    }
  }

  open() {
    this.previousElement = document.activeElement || this.cartDrawerToggle;

    this.cartDrawer.setAttribute("aria-hidden", "false");
    this.cartDrawer.classList.add("active");

    setTimeout(() => {
      this.querySelector("a[href]").focus();
    }, 100);
  }
  close() {
    // this.cartDrawerToggle.focus();
    this.previousElement.focus();

    this.cartDrawer.setAttribute("aria-hidden", "true");
    this.cartDrawer.classList.remove("active");

    var quickviewElement = document.querySelector(
      ".popup-modal-quickview:not(.inactive)"
    );
    if (quickviewElement) {
      quickviewElement.querySelector('button[type="submit"]').focus();
    }
  }

  formatPhoneNumber(event) {
    const input = event.target;
    const cursorPosition = input.selectionStart;
    const oldValue = input.value;
    let value = input.value.replace(/\D/g, ""); // Remove all non-digits

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    // Format based on length
    let formattedValue = "";
    if (value.length === 0) {
      formattedValue = "";
    } else if (value.length <= 3) {
      formattedValue = `(${value}`;
    } else if (value.length <= 6) {
      formattedValue = `(${value.substring(0, 3)}) ${value.substring(3)}`;
    } else {
      formattedValue = `(${value.substring(0, 3)}) ${value.substring(
        3,
        6
      )}-${value.substring(6)}`;
    }

    // Update input value
    input.value = formattedValue;

    // Adjust cursor position
    const oldLength = oldValue.length;
    const newLength = formattedValue.length;

    // Calculate new cursor position
    let newCursorPosition = cursorPosition;
    if (cursorPosition === oldLength) {
      // Cursor was at the end
      newCursorPosition = newLength;
    } else {
      // Count digits before cursor in old value
      const digitsBeforeCursor = oldValue
        .substring(0, cursorPosition)
        .replace(/\D/g, "").length;

      // Find position in new value where we have the same number of digits
      let digitsCount = 0;
      for (let i = 0; i < formattedValue.length; i++) {
        if (/\d/.test(formattedValue[i])) {
          digitsCount++;
          if (digitsCount === digitsBeforeCursor) {
            newCursorPosition = i + 1;
            break;
          }
        }
      }
      if (digitsCount < digitsBeforeCursor) {
        newCursorPosition = formattedValue.length;
      }
    }

    // Set cursor position
    input.setSelectionRange(newCursorPosition, newCursorPosition);

    // Validate format
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidFormat = phoneRegex.test(formattedValue);

    // Update validation state (visual feedback could be added here)
    if (formattedValue.length > 0 && !isValidFormat) {
      input.setAttribute("data-invalid", "true");
    } else {
      input.removeAttribute("data-invalid");
    }
  }

  validateCheckoutButton() {
    if (this.checkoutButton && this.phoneField && this.availabilityField) {
      const phoneValue = this.phoneField.value.trim();
      const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
      const isPhoneValid = phoneRegex.test(phoneValue);
      const availabilityValue = this.availabilityField.value.trim();
      const isValid = isPhoneValid && availabilityValue;

      if (isValid) {
        this.checkoutButton.removeAttribute("disabled");
      } else {
        this.checkoutButton.setAttribute("disabled", "disabled");
      }

      // Handle additional checkout buttons
      if (this.additionalButtonsContainer) {
        this.toggleAdditionalButtons(isValid);
      }
    }
  }

  toggleAdditionalButtons(enabled) {
    if (!this.additionalButtonsContainer) return;

    // Update the container class
    if (enabled) {
      this.additionalButtonsContainer.classList.remove(
        "cart-additional-buttons-disabled"
      );
    } else {
      this.additionalButtonsContainer.classList.add(
        "cart-additional-buttons-disabled"
      );
    }

    // Find all buttons and links within the additional buttons container
    const buttons = this.additionalButtonsContainer.querySelectorAll(
      "button, a, [role='button']"
    );

    buttons.forEach((button) => {
      if (enabled) {
        button.removeAttribute("disabled");
        button.removeAttribute("aria-disabled");
        button.style.pointerEvents = "";
        button.style.opacity = "";
        // Remove disabled class if present
        button.classList.remove(
          "disabled",
          "shopify-payment-button__button--disabled"
        );
      } else {
        button.setAttribute("disabled", "disabled");
        button.setAttribute("aria-disabled", "true");
        button.style.pointerEvents = "none";
        button.style.opacity = "0.5";
        // Add disabled class
        button.classList.add(
          "disabled",
          "shopify-payment-button__button--disabled"
        );
      }
    });
  }

  observeAdditionalButtons() {
    // Use MutationObserver to watch for dynamically added buttons
    const observer = new MutationObserver(() => {
      this.validateCheckoutButton();
    });

    observer.observe(this.additionalButtonsContainer, {
      childList: true,
      subtree: true,
    });

    // Also validate after a short delay to catch buttons added after initial render
    setTimeout(() => {
      this.validateCheckoutButton();
    }, 500);
  }
}

customElements.define("cart-drawer", CartDrawer);
